import LessonArea from './LessonArea';

export default LessonArea;
